/**
 * Helpers Functions
 */
import moment from 'moment';
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return (
      'rgba(' +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
      ',' +
      alpha +
      ')'
    );
  }
  throw new Error('Bad Hex');
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

export function truncateByWords(text, numWords) {
  // Split the text into words
  const words = text.split(/\s+/);

  // Take the first n words
  const truncatedWords = words.slice(0, numWords);

  // Join the words back into a string
  const truncatedText = truncatedWords.join(' ');

  return truncatedText;
}

export function truncateText(text, wordCount) {
  const words = text.split(' ');
  if (words.length <= wordCount) {
    return text;
  }
  return words.slice(0, wordCount).join(' ') + '...';
}

export function trancWord(str, limit) {
  str = str.split(' ');
  let summ = 0;
  for (let [index, value] of str.entries()) {
    summ += value.length;
    if (summ > limit) {
      let cutTolimit = str.slice(0, index);
      return str.slice(0, index).join(' ') + ' ' + '...';
    }
  }
  return str.join(' ');
}

/**
 * Get Date
 */
export function getTheDate(timestamp, format) {
  let time = timestamp * 1000;
  let formatDate = format ? format : 'MM-DD-YYYY';
  return moment(time).format(formatDate);
}

/**
 * Convert Date To Timestamp
 */
export function convertDateToTimeStamp(date, format) {
  let formatDate = format ? format : 'YYYY-MM-DD';
  return moment(date, formatDate).unix();
}

export const formatCurrency = (number) => {
  return Number(number).toLocaleString('fr-SN').toString() + ' CFA';
};

/**
 * Function to return current app layout
 */
export function getAppLayout(url) {
  let location = url.pathname;
  let path = location.split('/');
  return path[1];
}

/**
 *
 * @param {int} x
 * Thousand delimiter
 */
export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/**
 *
 * @param {*function} callback
 * @param {*number} delay
 * @param  {...any} args
 *
 */
export function debounce(callback, delay, ...args) {
  const timerClear = () => (clear = true);
  var clear = true;
  return (event) => {
    if (clear) {
      clear = false;
      setTimeout(timerClear, delay);
      callback(event, ...args);
    }
  };
}

export function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function getFirstLetterOfWords(str) {
  var acronym = '';
  let temp = str.split(' ');
  if (temp.length >= 2)
    acronym = temp[temp.length - 2].charAt(0) + temp[temp.length - 1].charAt(0);
  else acronym = str.charAt(0);
  // var matches = str.match(/\b(\w)/g);
  // if(!matches) return str.charAt(0);

  return acronym;
}

export function cleanObject(obj) {
  Object.keys(obj).map((key) => {
    if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });

  return obj;
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

/**
 * render function for breadcrumb
 * @param {*} route
 * @param {*} params
 * @param {*} routes
 * @param {*} paths
 */
export const itemRender = (route, params, routes, paths) => {
  const last = routes.indexOf(route) === routes.length - 1;
  return last ? (
    <span>{route.breadcrumbName}</span>
  ) : (
    <Link to={`/${paths.join('/')}`}>{route.breadcrumbName}</Link>
  );
};

/**
 *
 * @param {*} url URL need to download
 * Downlaod without pop-up block warning
 */
export const downloadFromLink = (url, filename) => {
  let link = document.createElement('a');
  link.download = filename;
  link.href = url;
  link.click();
  URL.revokeObjectURL(link.href);
};

/**
 *
 * @param {*} type
 * mapping customer source
 */

// /**
//  * Format number thousand seperator
//  * @param {*} num original number
//  */
// export const formatNumber = (number) => {
//   return Number(number).toLocaleString('fr-SN');
// };

export function formatDateTime(dateTime) {
  const now = new Date();
  const past = new Date(dateTime);
  const diffInSeconds = Math.floor((now - past) / 1000); // Difference in seconds

  if (diffInSeconds < 60) {
    // Less than 1 minute
    return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);

  if (diffInMinutes < 60) {
    // Less than 60 minutes
    const remainingSeconds = diffInSeconds % 60;
    return `${diffInMinutes} minute${
      diffInMinutes !== 1 ? 's' : ''
    } ${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);

  if (diffInHours < 24) {
    // Less than 24 hours
    const remainingMinutes = diffInMinutes % 60;
    return `${diffInHours} hour${
      diffInHours !== 1 ? 's' : ''
    } ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''} ago`;
  }

  // More than 24 hours
  const month = past.getMonth() + 1; // Months are zero-based
  const day = past.getDate();
  const hours = past.getHours();
  const minutes = past.getMinutes().toString().padStart(2, '0');

  return `${month}/${day} ${hours}:${minutes}`;
}

/** Hàm format hiện thị giá theo custom từ admin */
export function formatCurrencyCustom(amount, currency) {
  /** safe amount: nếu không phải số hợp lệ -> default 0 */
  const SAFE_AMOUNT =
    typeof amount === 'number' && Number.isFinite(amount) ? amount : 0;

  /** symbol fallback */
  const SYMBOL = currency?.sale_currency_symbol?.trim() || 'CFA';

  /** DECIMALS fallback */
  const DECIMALS =
    currency &&
    currency.sale_currency_decimal != null &&
    !Number.isNaN(Number(currency.sale_currency_decimal))
      ? Math.max(0, Number(currency.sale_currency_decimal))
      : 0;

  /**  format amount */
  const FORMATTED = SAFE_AMOUNT.toFixed(DECIMALS);

  /** xác định cách hiển thị (mặc định: số trước, symbol sau → "0 CFA") */
  const DISPLAY = currency?.sale_currency_display?.trim() || '0 CFA';

  if (DISPLAY.startsWith(SYMBOL)) {
    /** nếu cấu hình kiểu "CFA 0" thì để SYMBOL trước */
    return `${SYMBOL} ${formatNumber(FORMATTED)}`;
  } else {
    /** ngược lại thì để số trước */
    return `${formatNumber(FORMATTED)} ${SYMBOL}`;
  }
}

export function fillTemplate(template, data) {
  return template.replace(/{{(.*?)}}/g, (_, key) => data[key.trim()] ?? '');
}

/**
 * Format number thousand seperator
 * @param {*} num original number
 */
export function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
